import { z } from 'zod'

export const schema = z.object({
  villages: z.array(
    z.object({
      name: z.string(),
      slug: z.string(),
      description: z.string().nullable(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>
